'use client';

import { usePathname } from 'next/navigation';

import InstallPrompt from '@/app/install-prompt';
import UpdatePrompt from '@/app/update-prompt';
import { AppSidebar } from '@/components/app-sidebar';
import { Header } from '@/components/header';
import { Row, Stack } from '@/components/layout';
import { cn } from '@/lib/utils';

type AppShellProps = {
    children: React.ReactNode;
};

export function AppShell({ children }: AppShellProps) {
    const pathname = usePathname();
    const isAuthPage = pathname.startsWith('/auth');

    // On auth pages, render minimal layout without sidebar/header
    if (isAuthPage) {
        return <>{children}</>;
    }

    // On other pages, render full app shell with sidebar and header
    return (
        <>
            <Row className="size-full items-start">
                <AppSidebar />
                <Stack className="h-full grow gap-2 overflow-hidden pr-2 pb-2 pl-2 xl:pl-0">
                    <Stack
                        className={cn(
                            'grow rounded-br-xl rounded-bl-xl',
                            'border-border bg-background border border-t-0',
                            'overflow-hidden',
                            'relative',
                        )}
                    >
                        <Header />
                        {children}
                    </Stack>

                    <UpdatePrompt />
                    <InstallPrompt />
                </Stack>
            </Row>
        </>
    );
}
